import { render, staticRenderFns } from "./AwardGroupReview.vue?vue&type=template&id=f6586016&scoped=true&"
import script from "./AwardGroupReview.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardGroupReview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardGroupReview.vue?vue&type=style&index=0&id=f6586016&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6586016",
  null
  
)

export default component.exports